<template>
  <div class="app-container">
    <el-form ref="dataForm" :model="dataForm" :rules="rules" label-width="100px" class="demo-dataForm">
      <el-card shadow="never">
        <div slot="header" style="display: flex;align-items: center;">
          <div style="font-size: 16px;">提现审核配置</div>
          <el-button type="primary" style="margin-left: auto;" @click="submit('dataForm')">保存</el-button>
        </div>
        <el-row :gutter="10">
          <el-col :lg="12">
            <fieldset>
              <legend>代理商/场地方</legend>
              <el-form-item label="是否审核" prop="NeedVerify">
                <el-radio-group v-model="dataForm.NeedVerify">
                  <el-radio :label="0">不需要审核</el-radio>
                  <el-radio :label="1">审核</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="审核用时" prop="VerifyDay">
                <el-input v-model="dataForm.VerifyDay" placeholder="请输入">
                  <div slot="suffix">工作日</div>
                </el-input>
              </el-form-item>
            </fieldset>

          </el-col>
          <el-col :lg="12">
            <fieldset>
              <legend>用户</legend>
              <el-form-item label="是否审核" prop="UserNeedVerify">
                <el-radio-group v-model="dataForm.UserNeedVerify">
                  <el-radio :label="0">不需要审核</el-radio>
                  <el-radio :label="1">审核</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="审核用时" prop="UserVerifyDay">
                <el-input v-model="dataForm.UserVerifyDay" placeholder="请输入">
                  <div slot="suffix">工作日</div>
                </el-input>
              </el-form-item>
            </fieldset>

          </el-col>
        </el-row>
      </el-card>

    </el-form>

  </div>
</template>

<script>
import { getObj, putObj } from './api/config'
export default {
  name: 'SetCosts',
  data() {
    return {
      rules: {
        'NeedVerify': [{ required: true, message: '请输入' }],
        'VerifyDay': [{ required: true, message: '只能输入数字', pattern: /^\d+$/ }],
        'UserNeedVerify': [{ required: true, message: '请输入' }],
        'UserVerifyDay': [{ required: true, message: '请输入', pattern: /^\d+$/ }]
      },
      dataForm: {
        'SettingId': 0,
        'NeedVerify': 0,
        'VerifyDay': 0,
        'UserNeedVerify': 0,
        'UserVerifyDay': 0
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      getObj().then(res => {
        this.dataForm = res
      })
    },
    submit(dataForm) {
      this.$refs[dataForm].validate(valid => {
        if (valid) {
          putObj(this.dataForm).then(res => {
            if (res) {
              this.$message.success('修改成功')
              this.getList()
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
fieldset{
  border-color: #dcdfe6;
  border-style: solid;
}
</style>

